import { Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoDirective } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';
import { LoadingContainerComponent } from '../../../shared/components/loading-container/loading-container.component';
import { LanguageService } from '../../../shared/services/language.service';
import { ValidationErrorPipe } from '../../../shared/services/validation-error.pipe';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login-page',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ValidationErrorPipe,
    TranslocoDirective,
    MatIcon,
    LoadingContainerComponent,
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {
  private fb = inject(NonNullableFormBuilder);
  private authService = inject(AuthService);
  private languageService = inject(LanguageService);

  hidePassword = signal<boolean>(true);
  isLoading = toSignal(this.authService.isLoginInProgress$, { initialValue: false });

  form = this.fb.group({
    email: [environment.production ? '' : 'admin@7peak.pl', Validators.required],
    password: [environment.production ? '' : 'password', Validators.required],
  });

  login() {
    const email = this.form.value.email as string;
    const password = this.form.value.password as string;

    this.authService.login(email, password);
  }

  changeLang(code: string) {
    this.languageService.setLanguage(code);
  }

  get f() {
    return this.form.controls;
  }
}
